module.exports = __webpack_public_path__ + "img/verified-user-shield-check.093ec660.png";